// imports
import { Address } from 'abitype';
import { hexToSignature } from 'viem';
import { getAccount, signTypedData } from 'wagmi/actions';
import { generatePrivateKey, privateKeyToAccount } from 'viem/accounts';
import { readContract } from '../wagmi';
import { TEXTS } from '../../../constants';
import { sendMetaTransaction } from '../utils';
import { IWallet } from '../../../common/types';
import { IContractProps } from '../wagmi/types';
import ArbNova from '../abi/arbitrum_nova.json';
import ArbGeorli from '../abi/arbitrum_goerli.json';

// interfaces / types / consts
const L2Chain = (process.env.REACT_APP_ENVIRONMENT === 'prod' || process.env.REACT_APP_ENVIRONMENT === 'stage') ? ArbNova : ArbGeorli;
const MESSAGE_TYPES = {
  Message: [
    { name: 'DelegateWallet', type: 'address' },
    { name: 'Content', type: 'string' }
  ]
};
const MESSAGE_DOMAIN = { version: '1', name: 'Wallet Delegation' };
const MESSAGE_VALUE = {
  types: MESSAGE_TYPES,
  domain: MESSAGE_DOMAIN,
  primaryType: 'Message' as const,
  message: { DelegateWallet: '', Content: 'Delegate this device wallet for game operations.' }
};
const WL_WALLET_DELEGATION = L2Chain.contracts.WalletDelegation as IContractProps;

// exports - views
export function getOwned(): Promise<Address[]> {
  const { address } = getAccount();
  return readContract({
    args: [address],
    abi: WL_WALLET_DELEGATION.abi,
    chainId: Number(L2Chain.chainId),
    address: WL_WALLET_DELEGATION.address,
    functionName: 'getDelegateWalletsForEoa'
  }).then((data) => data as Address[]);
}

// exports - writers
export function addDelegateWallet(): Promise<IWallet> {
  const { address } = getAccount();
  const privateKey = generatePrivateKey();
  const { address: delegateWallet } = privateKeyToAccount(privateKey);
  MESSAGE_VALUE.message.DelegateWallet = delegateWallet;
  return signTypedData(MESSAGE_VALUE).then((signedMessage) => {
    const signature = hexToSignature(signedMessage);
    const props: IContractProps = {
      abi: WL_WALLET_DELEGATION.abi,
      functionName: 'addDelegateWallet',
      address: WL_WALLET_DELEGATION.address,
      args: [delegateWallet, address, signature.v, signature.r, signature.s]
    };
    return sendMetaTransaction(props, privateKey);
  }).then((receipt) => {
    if (receipt?.status === 1) { return Promise.resolve({ address: delegateWallet, privateKey }); }
    return Promise.reject(new Error(TEXTS.ERROR_REGISTER_DELEGATE_WALLET));
  });
}

// exports - default
export default { getOwned, addDelegateWallet };
